import { INFO } from '../actionTypes'

export const info = (photoId: string) => ({
  type: INFO.name,
  api: {
    url: 'photos/info',
    data: { photo_id: photoId },
  },
})
